const legalConsentTranslations = {
  en: {
    prefix: "I've read the ",
    privacyPolicy: 'Privacy Policy',
  },
  uk: {
    prefix: 'Я прочитав ',
    privacyPolicy: 'Політику конфіденційності',
  },
  ua: {
    prefix: 'Я прочитав ',
    privacyPolicy: 'Політику конфіденційності',
  },
  nl: {
    prefix: 'Ik heb de ',
    privacyPolicy: 'Privacyverklaring',
    suffix: ' gelezen',
  },
  fr: {
    prefix: "J'ai lu la ",
    privacyPolicy: 'Politique de confidentialité',
  },
  de: {
    prefix: 'Ich habe die ',
    privacyPolicy: 'Datenschutzrichtlinie',
    suffix: ' gelesen',
  },
  zh: {
    prefix: '我已阅读',
    privacyPolicy: '隐私政策',
  },
  cn: {
    prefix: '我已阅读',
    privacyPolicy: '隐私政策',
  },
};

export const getLegalConsentText = (languageCode) => {
  const code = `${languageCode || 'en'}`.toLowerCase();

  return legalConsentTranslations[code] || legalConsentTranslations.en;
};
